export function Plus() {
  return <path d="M15 20H25M20 15V25" stroke="currentColor" />
}
